import React from 'react';
import { Row, Col } from 'react-bootstrap';

import OrganizationSelect from './OrganizationSelect';
import PortfolioSelect from './PortfolioSelect';

function PageHeader(props) {
  const {
    titlePrepend,
    title,
    showOrganizationSelect,
    showPortfolioSelect,
    setOrganizations,
    isLoading,
  } = props;

  return (
    <Row className='justify-content-between px-3 py-4'>
      <Col md='auto'>
        <Row className='float-left'>
          <h4>
            {titlePrepend}
            {title}
          </h4>
        </Row>
      </Col>
      <Col md='auto'>
        <Row className='float-right'>
          {showPortfolioSelect && <PortfolioSelect isLoading={isLoading} />}
          {showOrganizationSelect && (
            <OrganizationSelect
              setOrganizations={setOrganizations}
              isLoading={isLoading}
            />
          )}
        </Row>
      </Col>
    </Row>
  );
}

export default PageHeader;
